import React from "react";
import { NumberInput } from "react-admin";

const FormTab = (props) => {
  const s = (fieldName) => `players.${props.index}.soccer.${fieldName}`;
  return (
    <>
      <NumberInput label="Player Game Count" source={s("playerGameCount")} />
      <NumberInput label="Total Goals" source={s("totalGoals")} />
      <NumberInput label="Assists" source={s("assists")} />
      <NumberInput label="Shutouts" source={s("shutouts")} />
    </>
  );
};

export default FormTab;
